import React from "react";
import { useDispatch } from "react-redux";
import { toggleSecondaryLeftBarAction } from "../redux/app/actions";

export const useLeftBarHook = () => {
  const dispatch = useDispatch();
  return {
    toggleLeftBar: (forceValue = null) => {
      dispatch(toggleSecondaryLeftBarAction(forceValue));
    },
  };
};
